import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';

/** 供應商管理 hub 導覽卡 — 對齊物料管理 materialMgmtNavigate。 */
const srmMgmtNavigate = [
  {
    to: ROUTES.purchaseOrder,
    title: '物料採購單',
    subtitle: '查詢與管理物料採購單',
    permission: PERM.PURCHASE_ORDER_READ,
  },
  {
    to: ROUTES.miscPurchaseOrder,
    title: '非庫存採購單',
    subtitle: '不入庫的採購單列表',
    permission: PERM.MISC_PURCHASE_ORDER_READ,
  },
  {
    to: ROUTES.supplier,
    title: '供應商管理',
    subtitle: '查詢與管理供應商主檔',
    permission: PERM.SUPPLIER_READ,
  },
];

export default srmMgmtNavigate;
